// instantShoegazer.js
import React from 'react';

const ProjectInfo3 = () => (
    
    <div className="hsk-text">

    <p>
      <strong>Description:</strong><br />
      Grünstadt Audio is my plan for a VST Audio Plugin company. Being a long time user of VST Audio Plugins for my music production work,
       having some contacts in the industry and knowing C++ programming put me in a good place to start this project.
    </p>
    
    <p>The first plugin is still in early stages of development</p>
    
    <p style={{ marginTop: '20px'}}>
    <strong>Features of the first plugin (Elements of Distortion):</strong><br />
            - 4 types of Distortion
    </p>
    <p>- Each color represents an element, which translates to a different sound distortion algorithm</p>
    <p>- Gain, Mix and Output knobs for extra control</p>
    <p>- High Quality Factory Presets</p>
    <p>- Possibility to save custom presets</p>
    <p><strong>The 1st image is a screenshot of the actual program.</strong></p>
    <p><strong>2nd image is a mockup of Grünstadt Audio's website.</strong></p>

    </div>


);

export default ProjectInfo3;
